import React, { FC } from 'react';
import Flex from '@vromo/ui/components/Flex';
import Switch from '@vromo/ui/components/Switch';
import Tooltip from '@vromo/ui/components/Tooltip';
import { qaLabelTestSites } from './../../../../../../../common-qa-labels/sites';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { useTranslation } from 'react-i18next';
import styles from './index.style';

const LOCALE_NO_POLICIES = 'To enable auto dispatch you must first create an Auto Dispatcher';

interface Props {
    autoDispatchEnabled: boolean;
    hasPolicies: boolean;
    showTooltip: boolean;
    onChange: () => void;
}

const AutodispatcherHeader: FC<Props> = ({
    autoDispatchEnabled,
    hasPolicies,
    showTooltip,
    onChange
}) => {
    const { t } = useTranslation();

    const toggle = (
        <Switch
            testId={qaLabelTestSites.addSiteModal.autoDispatchToggle}
            checked={autoDispatchEnabled}
            disabled={!hasPolicies}
            onChange={onChange}
            style={styles.toggle}
        />
    );

    return (
        <Flex horizontal="left" vertical="middle">
            <label>{t('editSiteModal.autoDispatcherLabel')}</label>
            {showTooltip && (
                <Tooltip label={t('editSiteModal.accountLevelTooltip')}>
                    <div style={styles.headerTooltip}>
                        <FontAwesome icon="info-circle" />
                    </div>
                </Tooltip>
            )}
            {!hasPolicies ? (
                <Tooltip label={t('editSiteModal.localeNoPolicies')}>
                    <div>{toggle}</div>
                </Tooltip>
            ) : (
                toggle
            )}
        </Flex>
    );
};

export default AutodispatcherHeader;
